import * as Yup from "yup";

/** Aligns with backend `changePasswordSchema` (min length, new ≠ current). */
export const changePasswordSchema = Yup.object({
  currentPassword: Yup.string()
    .trim()
    .required("Current password is required")
    .min(1, "Current password is required"),
  newPassword: Yup.string()
    .required("New password is required")
    .min(6, "Password must be at least 6 characters long")
    .test(
      "differs-from-current",
      "New password must differ from your current password",
      function (value) {
        const current = this.parent.currentPassword as string | undefined;
        if (value == null || current == null) return true;
        return String(value) !== String(current);
      },
    ),
  confirmPassword: Yup.string()
    .required("Please confirm your new password")
    .oneOf([Yup.ref("newPassword")], "Passwords must match"),
});

export default changePasswordSchema;
